import { FeatureToggle } from '../../types'

export const featureEnabled = (feature: string, featureToggles: Array<FeatureToggle>): boolean => {
  const featureToggleName = (feature || '').toLowerCase()
  const featureToggle = (featureToggles || []).find(ft => ft.name.toLowerCase() === featureToggleName)
  return featureToggle !== undefined && featureToggle.enabled
}
